/**
 * DO NOT ADD TO THIS LIST OF EVENTS
 * legacyEvents are just that. We do not want to add to this list.
 * New events should follow the JC Segment Events Framework
 */
const legacyEvents = {
  // Signup events
  accountCreated: 'Account Created',
  accountCreateFailed: 'Account Create Failed',
  accountVerified: 'Account Verified',
  emailRegexFrontendBackendMismatch: 'Email Regex Frontend Backend Mismatch',
  loginRedirectionPage: 'Click On Redirection Page After Google Login',
  referralSourceSignup: 'Referral Source Signup',
  requestDemoClicked: 'Signup Request Demo Clicked',
  resendVerificationEmailAfterError: 'Resend Verification Email After Error',
  resendVerificationEmailBeforeError: 'Resend Verification Email Before Error',
  segmentUserIdMapping: 'Segment User ID Mapping',
  signupCancelled: 'Signup Cancelled',
  signupLoginLinkClicked: 'Signup Login Link Clicked',
  signupPageViewed: 'Signup Page Viewed',
  signupStepBack: 'Signup Step Back',
  signupStepCompleted: 'Signup Step Completed',
  signupSubmitted: 'Signup Submitted',
  signupUtmData: 'Signup UTM Data',
  signupWithGoogleClicked: 'Signup With Google Clicked',
  useCaseSelected: 'Use Case Selected',
  verificationHelpExpanded: 'Verification Having Trouble Expanded',
};

const genericEvents = {
  buttonClicked: 'Button Clicked',
  linkClicked: 'Link Clicked',
  modalViewed: 'Modal Viewed',
};

/**
 * DO NOT ADD TO THIS LIST OF EVENTS
 * We may need to add to genericEvents object above
 * If we need to add to genericEvents we want to follow the JC Segment Framework
 * A list of event names that are tracked throughout the UI via Segment.
 */
export const events = {
  ...genericEvents,
  ...legacyEvents,
};

export const eventProperties = {
  description: 'Description',
  displayLogic: 'Display Logic',
  location: 'Location',
  section: 'Section',
  text: 'Text',
  toUrl: 'To URL',
};

export const eventLocations = {
  signup: 'Sign Up',
};
